"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhitespaceMatcher = exports.VariableMatcher = exports.StringMatcher = exports.SpreadMatcher = exports.SpeechDoubleMatcher = exports.SpeechSingleMatcher = exports.PlaceholderMatcherAlt = exports.PlaceholderMatcher = exports.SquareParensMatcher = exports.ParensMatcher = exports.OperatorMatcher = exports.NumberMatcher = exports.InvalidDecimalMatcher = exports.InvalidOpTripletMatcher = exports.InvalidOpComboMatcher = exports.IntegerMatcher = exports.FunctionMatcher = exports.DollarMatcher = exports.ComparisonMatcher = exports.CommaMatcher = void 0;
const types_1 = require("./types");
// @ts-ignore
const mathMethods = Object.getOwnPropertyNames(Math).filter((key) => typeof Math[key] === 'function')
    .concat(['int', 'dp', 'sf', 'degToRad', 'radToDeg'])
    .join('|');
const arrayMethods = ['join', 'sum'].join('|');
exports.CommaMatcher = [/^,/, types_1.TokenType.COMMA];
exports.ComparisonMatcher = [/^(!==|===|<=|<|>=|>|!)/, types_1.TokenType.COMPARISON];
exports.DollarMatcher = [/^\$/, types_1.TokenType.STRING];
exports.FunctionMatcher = [/^\w+\(/, types_1.TokenType.FUNCTION];
exports.IntegerMatcher = [/^-?\d+/, types_1.TokenType.INTEGER];
exports.InvalidOpComboMatcher = [/^[-+*/](\s+)?[*/]/, types_1.TokenType.INVALID];
exports.InvalidOpTripletMatcher = [/^[-+*/]{3}/, types_1.TokenType.INVALID];
exports.InvalidDecimalMatcher = [/^\./, types_1.TokenType.INVALID];
exports.NumberMatcher = [/^-?\d+(.\d+)?/, types_1.TokenType.NUMBER];
exports.OperatorMatcher = [/^[-+*/^%?:]/, types_1.TokenType.OPERATOR];
exports.ParensMatcher = [/^[()]/, types_1.TokenType.PARENS];
exports.SquareParensMatcher = [/^[\[\]]/, types_1.TokenType.SQUARE_PARENS];
exports.PlaceholderMatcher = [/^\${.+?}/, types_1.TokenType.PLACEHOLDER];
exports.PlaceholderMatcherAlt = [/^§.+?§/, types_1.TokenType.PLACEHOLDER];
exports.SpeechSingleMatcher = [/^'.*?'/, types_1.TokenType.SPEECH];
exports.SpeechDoubleMatcher = [/^".*?"/, types_1.TokenType.SPEECH];
exports.SpreadMatcher = [/^\.\.\./, types_1.TokenType.SPREAD];
exports.StringMatcher = [/^[^§$]+/, types_1.TokenType.STRING];
exports.VariableMatcher = [/^\w+(\.\w+)*/, types_1.TokenType.VARIABLE];
exports.WhitespaceMatcher = [/^\s+/, types_1.TokenType.WHITESPACE];
